<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import { welfareConfig as rocnovelConfig } from '../../configs/rocnovel'
import { welfareConfig as ocereadConfig } from '../../configs/oceread'
import { welfareConfig as ficmoonConfig } from '../../configs/ficmoon'
import { welfareConfig as novelarcConfig } from '../../configs/novelarc'
import { welfareConfig as storyellaConfig } from '../../configs/storyella'
import { welfareConfig as aurenovelConfig } from '../../configs/aurenovel'
import { welfareConfig as florastoryConfig } from '../../configs/florastory'
import { welfareConfig as novelsprigConfig } from '../../configs/novelsprig'
import { welfareConfig as silktaleConfig } from '../../configs/silktale'
import { welfareConfig as pearlaConfig } from '../../configs/pearla'
import { welfareConfig as freeficConfig } from '../../configs/freefic'
import { welfareConfig as fictoraConfig } from '../../configs/fictora'
import { welfareConfig as marinovelConfig } from '../../configs/marinovel'
import { welfareConfig as flipnovelConfig } from '../../configs/flipnovel'
import { welfareConfig as moonpageConfig } from '../../configs/moonpage'
import { welfareConfig as noveluneConfig } from '../../configs/novelune'
import { welfareConfig as storlynConfig } from '../../configs/storlyn'
import { welfareConfig as novelmelloConfig } from '../../configs/novelmello'
import { isInThirdAppBrowser } from '@/utils/bowserEnv'
import { $getToken } from '@/helpers'
import { loadBrandConfig } from '@/utils/loadBrandConfig'

const props = withDefaults(defineProps<{
  value: boolean
}>(), {
  value: false,
})

const emit = defineEmits<{
  (event: 'input', value: boolean): void
}>()

// 加载当前品牌的 welfare 配置
const config = loadBrandConfig({
  rocnovel: rocnovelConfig,
  oceread: ocereadConfig,
  ficmoon: ficmoonConfig,
  novelarc: novelarcConfig,
  storyella: storyellaConfig,
  aurenovel: aurenovelConfig,
  florastory: florastoryConfig,
  silktale: silktaleConfig,
  pearla: pearlaConfig,
  freefic: freeficConfig,
  fictora: fictoraConfig,
  marinovel: marinovelConfig,
  flipnovel: flipnovelConfig,
  moonpage: moonpageConfig,
  novelune: noveluneConfig,
  storlyn: storlynConfig,
  novelmello: novelmelloConfig,
  novelsprig: novelsprigConfig,
})

const show = ref(false)
const setToken = function () {
  const t = $getToken() || ''
  const url = new URL(window.location.href)

  if (isInThirdAppBrowser())
    url.searchParams.set('bt', t)

  history.replaceState({}, '', url.href)
}

const removeToken = function () {
  const url = new URL(window.location.href)
  if (url.searchParams.has('bt'))
    url.searchParams.delete('bt')

  history.replaceState({}, '', url.href)
}

watch(
  () => props.value,
  () => {
    show.value = props.value
  },
)
watch(
  () => show.value,
  (value) => {
    emit('input', value)

    if (value)
      setToken()

    if (!value)
      removeToken()
  },
)

const upArrowTop = computed(() => {
  return window.innerHeight / 2 - 110
})
</script>

<template>
  <BasicModal v-model="show">
    <div class="p-5 text-n-text-1 home-bg">
      <div class="text-16px font-medium text-center">
        <p>{{ config.texts.guideOpenTitle }}</p>
      </div>
      <div class="text-n-primary font-bold text-center mt-2">
        <p>{{ config.texts.guideOpenAction }}</p>
      </div>
    </div>

    <img src="@/assets/up-arrow.png" class="fixed w-48px left-80%" :style="{ top: `-${upArrowTop}px` }">
  </BasicModal>
</template>

<style lang="scss" scoped>
.home-bg {
  border-radius: 12px;
  overflow: hidden;
}
</style>
